import { useContext } from 'react';

import { ViewportContext, ViewportInfo } from '~Context/ViewportContext';

const useViewport = (): ViewportInfo => useContext<ViewportInfo>(ViewportContext);

export default useViewport;
